<template>
  <div class="not-found-page text-center d-flex">
    <div class="mx-auto my-auto">
      <h1 class="title-404">404</h1>
      <p class="mb-8">Сторінку не знайдено</p>
      <v-btn dark @click="$router.push('/')">На головну</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'not-found-page',
  metaInfo: {
    title: 'Сторінку не знайдено | Transport Map'
  }
}
</script>

<style>
  .not-found-page {
    min-height: calc(100vh - 100px);
  }
  .not-found-page .title-404 {
    font-size: 7rem;
  }
</style>